module.exports = __webpack_public_path__ + "img/low-set.5dc786f0.png";